// tslint:disable-next-line: no-any
export type Constructor<T = {}> = new (...args: Array<any>) => T;

// tslint:disable-next-line: no-any
export function applyMixins(mixin: any, individuals: Array<any>): void {
  individuals.forEach(individual => {
    Object.getOwnPropertyNames(individual.prototype).forEach(name => {
      mixin.prototype[name] = individual.prototype[name];
    });
  });
}

export class Base {
  // tslint:disable-next-line: no-empty no-any
  constructor(...args: Array<any>) {}
}
